import Navigation from "@/components/Navigation"
import Footer from "@/components/Footer"

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-display font-bold mb-8 mt-6 text-center">Politique de confidentialité</h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">Collecte des données personnelles</h2>
              <p className="text-muted-foreground">
                Nous collectons les données personnelles que vous nous fournissez volontairement lors de :
              </p>
              <ul className="list-disc pl-6 text-muted-foreground">
                <li>La création de votre compte ;</li>
                <li>L'inscription à notre newsletter ;</li>
                <li>La passation de commande ;</li>
                <li>Le contact avec notre service client.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">1. Préambule</h2>
              <p className="text-muted-foreground">
                Le Règlement (EU) 2016/679 du Parlement Européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement de données à caractère personnel et à la libre circulation de ces données, autrement appelé le Règlement général sur la protection des données (ci-après RGPD) fixe le cadre juridique applicable aux traitements de données à caractère personnel.
<br/><br/>

Le RGPD renforce les droits et les obligations des responsables de traitements, des sous-traitants, des personnes concernées et des destinataires des données.
Dans le cas de notre activité nous sommes amenés à traiter des données à caractère personnel.<br/>
Pour une bonne compréhension de la présente politique il est précisé que :<br/>
<ul className="list-disc pl-6 text-muted-foreground">
<li>Le « responsable du traitement » : WEMEMBERZ ;</li>
<li>Le « sous-traitant » : Désigne toute personne physique ou morale qui traite des données à caractère personnel pour le compte de WEMEMBERZ ;</li>
<li>Les « personnes concernées » : Désigne les clients et/ou les prospects de WEMEMBERZ ;</li>
<li>Les « destinataires » : Désigne les personnes physiques ou morales qui reçoivent des données à caractère personnel de la part de WEMEMBERZ. Les destinataires des données peuvent donc être aussi bien des salariés de WEMEMBERZ que des organismes extérieurs (partenaires, exposants, établissement bancaire, intervenants, etc.).</li>
</ul>
  <br/>
Le RGPD, en son article 12, impose que les personnes concernées soient informées de leurs droits de manière concise, transparente, compréhensible et aisément accessible.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2. Objet</h2>
              <p className="text-muted-foreground">
                La présente politique a pour objet de satisfaire à l'obligation d'information à laquelle WEMEMBERZ est tenue en application du RGPD (article 12) et de formaliser les droits et les obligations des clients et prospects de WEMEMBERZ au regard du traitement de leurs données à caractère personnel.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">3. Portée</h2>
              <p className="text-muted-foreground">
                La présente politique a vocation à s'appliquer dans le cadre de la mise en place de l'ensemble des traitements de données à caractère personnel relatives aux clients et/ou prospects.

<br/><br/>
WEMEMBERZ met tout en œuvre pour que les données soient traitées dans le cadre d'une gouvernance interne précise. Ceci étant précisé, la présente politique ne porte que sur les traitements dont WEMEMBERZ est responsable du traitement et ne vise donc pas les traitements qui ne seraient pas créés ou exploités en dehors des règles de gouvernance fixées par WEMEMBERZ (traitement dit « sauvages » ou shadow IT).
<br/><br/>
Le traitement de données à caractère personnel peut être géré directement par WEMEMBERZ ou par le biais d'un sous-traitant spécifiquement désigné par WEMEMBERZ.<br/>
Cette politique est indépendante de tout autre document pouvant s'appliquer au sein de la relation contractuelle entre WEMEMBERZ et les clients et prospects.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">4. Principes généraux & collecte des données</h2>
              <p className="text-muted-foreground">
                Aucun traitement n'est mis en œuvre chez WEMEMBERZ concernant des données de clients et prospects s'il ne porte pas sur des données à caractère personnel collectées par ou pour nos services ou traitées en relation avec nos services et s'il ne répond pas aux principes généraux du RGPD.
<br/><br/>

Les cas d'usage de WEMEMBERZ sont les suivants :<br/>
<ul className="list-disc pl-6 text-muted-foreground">
<li>Jeux et concours :</li>
  <ul className="list-disc pl-6 text-muted-foreground">
<li>Toute démarche ludique destinée ou non à faire gagner un gain aux clients ou aux prospects de WEMEMBERZ ;</li>
<li>Généralement les données collectées sont celles nécessaires à l'identification des participants et l'attribution des gains ou des lots.</li>
  </ul>
    <li>Push media :</li>
  <ul className="list-disc pl-6 text-muted-foreground">
<li>Toutes démarches de nature commerciale, suivi commercial ;</li>
<li>Prospection, généralement par courrier électronique, SMS, téléphone…Les données sont collectées selon les cas d'usage en opt in ou en opt out.</li>
  </ul>
    <li>Évènement :</li>
  <ul className="list-disc pl-6 text-muted-foreground">
<li>Manifestations physiques organisées par WEMEMBERZ ou auxquelles WEMEMBERZ participe ou sponsorise ;</li>
<li>Les données sont généralement collectées lors de l'inscription à l'événement (directement ou via un partenaire) ou lors de l'événement lui-même (bulletin, questionnaire, carte de visite, applications mobiles dédiées, …).</li>
  </ul>
    <li>Médias sociaux :</li>
  <ul className="list-disc pl-6 text-muted-foreground">
<li>Toutes opérations de social selling ;</li>
<li>Elles regroupent notamment le recueil de données liées à des inscriptions, posts, likes, reply et forwards, commentaires, avis...</li>
  </ul>
  </ul><br/>
  Cette liste se veut aussi exhaustive que possible, tout nouveau cas d'usage, modification ou suppression d'un traitement existant sera porté à la connaissance des clients et prospects par une modification de la présente politique.
                <br/>
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">5. Types de données collectées</h2>
              <p className="text-muted-foreground">
                Données non techniques (selon les cas d'usage) :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Identification (nom, prénom, pseudo, ...) ;</li>
<li>Photos ;</li>
<li>Vie personnelle/professionnelle lorsque c'est nécessaire ;</li>
<li>Données bancaires ;</li>
<li>Date d'anniversaire.</li>
</ul><br/>
  
Données techniques (selon les cas d'usage) :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Données d'identification (IP) ;</li>
<li>Données de connexion (logs notamment) ;</li>
<li>Données d'acceptation (clic) ;</li>
<li>Données de localisation.</li>
  </ul>
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">6. Origines des données</h2>
              <p className="text-muted-foreground">
                Les données relatives à nos clients ou prospects sont généralement collectées directement auprès d'eux (collecte directe).

<br/><br/>
La collecte peut aussi être indirecte :
                <ul className="list-disc pl-6 text-muted-foreground">
<li>Via des entreprises spécialisées (achat ou location de base) ou via les partenaires et fournisseurs de WEMEMBERZ. Dans ce cas WEMEMBERZ prend le plus grand soin à s'assurer de la qualité des données qui lui sont communiquées ;</li>
<li>Via d'autres clients de WEMEMBERZ (par exemple : mise en commun par un client d'un album photo suite à un événement, envoi d'un produit WEMEMBERZ par un client à un tiers etc.) ;</li>
<li>Via du parrainage. Dans ce cas, le parrain s'assure qu'il peut nous communiquer les données de la personne.</li>
                </ul>      
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">7. Finalités et bases légales</h2>
              <p className="text-muted-foreground">
                Selon les cas, WEMEMBERZ traite vos données pour les finalités suivantes :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Gestion de la relation client (GRC) ;</li>
<li>Gestion de la relation prospect (GRP) ;</li>
<li>Community management ;</li>
<li>Souscription à des services ;</li>
<li>Achat en ligne ;</li>
<li>Gestion des demandes de désinscription et de désabonnement ;</li>
<li>Gestion des signalements de comportements contraires aux présentes ;</li>
<li>Conservation des données relative aux obligations légales de sécurité ;</li>
<li>Amélioration des services et enquête de satisfaction ;</li>
<li>Analyse comportementale et ciblage ;</li>
<li>Statistiques ;</li>
<li>Prospection commerciale (envoi de newsletters, opérations de promotion, par exemple code promotion à la date d'anniversaire, etc.).</li>
</ul>
  <br/>
                Ces finalités reposent sur l'intérêt légitime de WEMEMBERZ de disposer de données concernant ses clients et ses prospects.

<br/><br/>
Lorsque c'est nécessaire, WEMEMBERZ recueille le consentement des personnes.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">8. Destinataires des données – habilitation & traçabilité</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ s'assure que les données ne soient accessibles qu'à des destinataires internes ou externes habilités.

 <br/> <br/>
<b>Destinataires internes</b>
                <ul className="list-disc pl-6 text-muted-foreground">
<li>Le personnel habilité du service marketing, du service commercial, des services chargés de traiter la relation client et la prospection, des services administratifs, des services logistiques et informatiques ainsi que leurs responsables hiérarchiques ;</li>
<li>Le personnel habilité des services chargés du contrôle (commissaire aux comptes, services chargés des procédures internes du contrôle, etc.) ;</li>
<li>Le personnel habilité des sous-traitants.</li>
                </ul><br/>
<b>Destinataires externes</b>
                <ul className="list-disc pl-6 text-muted-foreground">
<li>Les partenaires, les sociétés extérieures ou les filiales d'un même groupe de sociétés ;</li>
<li>Organismes, les auxiliaires de justice et les officiers ministériels, dans le cadre de leur mission de recouvrement de créances ;</li>
<li>L'organisme en charge de la gestion de la liste d'opposition au démarchage téléphonique ;</li>
<li>Le personnel habilité des sous-traitants.</li>
                </ul>
 <br/>
Les destinataires des données à caractère personnel des clients et prospects au sein de WEMEMBERZ sont soumis à une obligation de confidentialité.

 <br/> <br/>
WEMEMBERZ décide quel destinataire pourra avoir accès à quelle donnée selon une politique d'habilitation.

 <br/> <br/>
Tous les accès concernant des traitements relatifs à des données à caractère personnel de clients et prospects font l'objet d'une mesure de traçabilité.

 <br/> <br/>
Par ailleurs, les données à caractère personnel pourront être communiquées à toute autorité légalement habilitée à en connaître. Dans ce cas, WEMEMBERZ n'est pas responsable des conditions dans lesquelles les personnels de ces autorités ont accès et exploitent les données.
               
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">9. Durée de conservation</h2>
              <p className="text-muted-foreground">
                La durée de conservation des données est définie par WEMEMBERZ au regard des contraintes légales et contractuelles qui pèsent sur elle.

 <br/> <br/>
Passé ces délais, les données sont soit supprimées, soit conservées après avoir été anonymisées, notamment pour des raisons d'usages statistiques. Elles peuvent être conservées en cas de précontentieux et contentieux.

 <br/> <br/>
Il est rappelé aux clients et prospects que la suppression ou l'anonymisation sont des opérations irréversibles et que WEMEMBERZ n'est plus, par la suite, en mesure de les restaurer.
               
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">10. Droit de confirmation et droit d'accès</h2>
              <p className="text-muted-foreground">
                Les clients et prospects disposent d'un droit de demander à WEMEMBERZ la confirmation que des données le concernant sont ou non traitées.

 <br/> <br/>
Les clients et prospects disposent également d'un droit d'accès, ce dernier étant conditionné au respect des règles suivantes :
 <br/>
<ul className="list-disc pl-6 text-muted-foreground">
<li>La demande émane de la personne elle-même et est accompagnée d'une copie d'un titre d'identité, à jour.</li>
</ul>
                <br/>
  Les clients et prospects ont le droit de demander une copie de leurs données à caractère personnel faisant l'objet du traitement auprès de WEMEMBERZ. Toutefois, en cas de demande de copie supplémentaire, WEMEMBERZ pourra exiger la prise en charge financière de ce coût par les clients et prospects.
 <br/>
Si les clients et prospects présentent leur demande de copie des données par voie électronique, les informations demandées lui seront fournies sous une forme électronique d'usage courant, sauf demande contraire.

 <br/> <br/>
Les clients et prospects sont informés que ce droit d'accès ne peut porter sur des informations ou données confidentielles ou encore pour lesquelles la loi n'autorise pas la communication.
 <br/> <br/>

Le droit d'accès ne doit pas être exercé de manière abusive c'est-à-dire réalisé de manière régulière dans le seul but de déstabiliser le service concerné.
               
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">11. Mise à jour – actualisation et rectification</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ satisfaire aux demandes de mise à jour :

<ul className="list-disc pl-6 text-muted-foreground">
<li>Automatiquement pour les modifications en ligne sur des champs qui techniquement ou légalement peuvent être mis à jour ;</li>
<li>Sur demande écrite émanant de la personne elle-même qui doit justifier de son identité.</li>
</ul>
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">12. Droit à l'effacement</h2>
              <p className="text-muted-foreground">
                Le droit à l'effacement des clients et prospects ne sera pas applicable dans les cas où le traitement est mis en œuvre pour répondre à une obligation légale.
<br/><br/>

En dehors de cette situation, les clients et prospects pourront demander l'effacement de leurs données dans les cas limitatifs suivants :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Les données à caractère personnel ne sont plus nécessaires au regard des finalités pour lesquelles elles ont été collectées ou traitées d'une autre manière ;</li>
<li>Lorsque la personne concernée retire le consentement sur lequel est fondé le traitement et qu'il n'existe pas d'autre fondement juridique au traitement ;</li>
<li>La personne concernée s'oppose à un traitement nécessaire aux fins des intérêts légitimes poursuivis par WEMEMBERZ et qu'il n'existe pas de motif légitime impérieux pour le traitement ;</li>
<li>La personne concernée s'oppose à un traitement de ses données à caractère personnel à des fins de prospection, y compris au profilage ;</li>
<li>Les données à caractère personnel ont fait l'objet d'un traitement illicite.</li>
</ul>
  <br/>
                Conformément à la législation sur la protection des données à caractère personnel, les clients et prospects sont informés qu'il s'agit d'un droit individuel qui ne peut être exercé que par la personne concernée relativement à ses propres informations : pour des raisons de sécurité, le service concerné devra donc vérifier votre identité afin d'éviter toute communication d'informations confidentielles vous concernant à une autre personne que vous.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">13. Droit à la limitation</h2>
              <p className="text-muted-foreground">
                Les clients et prospects sont informés de ce que droit n'a pas vocation à s'appliquer dans la mesure où le traitement opéré par WEMEMBERZ est licite et que toutes les données à caractère personnel collectées sont nécessaires à l'exécution du contrat commercial.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">14. Droit à la portabilité</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ fait droit à la portabilité des données dans le cas particulier des données communiqués par les clients ou les prospects eux-mêmes, sur des services en ligne proposés par WEMEMBERZ elle-même et pour les finalités reposant sur le seul consentement des personnes. Dans ce cas, les données seront communiquées dans un format structuré, couramment utilisé et lisible par une machine.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">15. Décision individuelle automatisée</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ ne procède pas à des décisions individuelles automatisées.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">16. Droit post mortem</h2>
              <p className="text-muted-foreground">
                Les clients et prospects sont informés qu'ils disposent du droit de formuler des directives concernant la conservation, l'effacement et la communication de leurs données post-mortem. La communication de directives spécifiques post-mortem et l'exercice de leurs droits s'effectuent par courrier électronique à l'adresse contact@wememberz.com accompagné d'une copie d'un titre d'identité signé.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">17. Caractère facultatif ou obligatoire des réponses</h2>
              <p className="text-muted-foreground">
                Les clients et prospects sont informés sur chaque formulaire de collecte des données à caractère personnel du caractère obligatoire ou facultatif des réponses par la présence d'un astérisque.
<br/><br/>
Dans le cas où des réponses sont obligatoires, WEMEMBERZ explique aux clients et prospects les conséquences d'une absence de réponse
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">18. Droit d'usage</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ se voit conférer par les clients et prospects un droit d'usage et de traitement de leurs données à caractère personnel pour les finalités exposées ci-dessus.
 <br/> <br/>

Toutefois, les données enrichies qui sont le fruit d'un travail de traitement et d'analyse de WEMEMBERZ, autrement appelées les données enrichies, demeurent la propriété exclusive de WEMEMBERZ (analyse d'usage, statistiques, etc.).
               
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">19. Sous-traitance</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ informe ses clients et prospects qu'elle pourra faire intervenir tout sous-traitant de son choix dans le cadre du traitement de leurs données à caractère personnel.
<br/><br/>

Dans ce cas, WEMEMBERZ s'assure du respect par le sous-traitant de ses obligations en vertu du RGPD.

<br/><br/>
WEMEMBERZ se réserve le droit de procéder à un audit auprès de ses sous-traitants afin de s'assurer du respect des dispositions du RGPD.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">20. Sécurité</h2>
              <p className="text-muted-foreground">
                Il appartient à WEMEMBERZ de définir et de mettre en œuvre les mesures techniques de sécurité, physiques ou logiques, qu'elle estime appropriées pour lutter contre la destruction, la perte, l'altération ou la divulgation non autorisée des données de manière accidentelle ou illicite.

<br/><br/>
Parmi ces mesures figurent principalement :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Gestion des habilitations pour l'accès aux données ;</li>
<li>L'utilisation d'un protocole ou de solutions de sécurité.</li>
</ul>      
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">21. Violation de données</h2>
              <p className="text-muted-foreground">
              En cas de violation de données à caractère personnel, WEMEMBERZ s'engage à en notifier à la CNIL dans les conditions prescrites par le RGPD.

<br/><br/>
Si ladite violation fait porter un risque élevé pour les clients et prospects et que les données n'ont pas été protégées, WEMEMBERZ :
<ul className="list-disc pl-6 text-muted-foreground">
<li>En avisera les clients et prospects concernés ;</li>
<li>Communiquera aux clients et prospects concernés les informations et recommandations nécessaires.</li>
</ul>
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">22. Registre des traitements</h2>
              <p className="text-muted-foreground">
                WEMEMBERZ, en tant que responsable du traitement, s'engage à tenir à jour un registre de toutes les activités de traitement effectuées.

<br/><br/>
Ce registre est un document ou applicatif permettant de recenser l'ensemble des traitements mis en œuvre par WEMEMBERZ, en tant que responsable du traitement.
<br/><br/>

WEMEMBERZ s'engage à fournir à l'autorité de contrôle, à première demande, les renseignements permettant à ladite autorité de vérifier la conformité des traitements à la réglementation informatique et libertés en vigueur.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">23. Droit d'introduire une réclamation auprès de la CNIL</h2>
              <p className="text-muted-foreground">
                Les clients et prospects concernés par le traitement de leurs données à caractère personnel sont informés de leur droit d'introduire une plainte auprès d'une autorité de contrôle, à savoir la CNIL en France, si celui-ci estime que le traitement de données à caractère personnel le concernant n'est pas conforme à la réglementation européenne de protection des données, à l'adresse suivante :

<br/><br/>
CNIL – Service des plaintes

<br/>
3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07
<br/>

Tél : 01 53 73 22 22
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">23. Évolution
</h2>
              <p className="text-muted-foreground">
                La présente politique peut être modifiée ou aménagée à tout moment en cas d'évolution légale, jurisprudentielle, des décisions et recommandations de la Cnil ou des usages.
<br/><br/>

Toute nouvelle version de la présente politique sera portée à la connaissance des clients et contacts par tout moyen défini par WEMEMBERZ, en ce compris la voie électronique (diffusion par courrier électronique ou en ligne par exemple).
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">24. Pour plus d'informations</h2>
              <p className="text-muted-foreground">
                Pour toutes informations complémentaires, vous pouvez contacter les services suivants : contact@wememberz.com

<br/><br/>
Pour toute autre information plus générale sur la protection des données personnelles, vous pouvez consulter le site de la CNIL www.cnil.fr.
                
              </p>
            </section>


          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
